module.exports = __webpack_public_path__ + "assets/img/map_en.ed2e9534.png";